import { useEffect } from 'react';

export default (refs, handler) => {
  useEffect(() => {
    const listener = (event) => {
      const refArray = Array.isArray(refs) ? refs : [refs];
      const clicked = refArray.some((ref) => ref?.current && ref.current.contains(event.target));

      if (clicked) return;

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handler]);
};
